type HostWindow = Window & { __MAIN_APP_BASE_URL__?: string }

/**
 * 使用 `__MAIN_APP_BASE_URL__`（见 `src/index.tsx`）与子路径拼绝对 URL 后 `window.open`，
 * 避免微前端/新标签里相对路径被解析到错误域名。
 */
export function openMainAppRoute(path: string, target = '_blank') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const hostWindow = window as HostWindow
  const baseUrl = hostWindow.__MAIN_APP_BASE_URL__ ?? window.location.origin
  const href = new URL(normalizedPath, baseUrl).toString()
  try {
    window.open(href, target, 'noopener')
  } catch (error) {
    console.warn('openMainAppRoute failed, fallback to location.assign', error)
    window.location.assign(href)
  }
}
